<template>
  <BaseTemplate :currentUser="currentUser">
    <div class="specific-commerce">
      <Title eng="TERMS OF SALE" :jpn="t('特定商取引法に基づく表記')" />
      <div class="scroll-container">
        <!-- <Title eng="TERMS OF SALE" jpn="現在準備中" /> -->
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          :title="t('販売業者')"
        >
          <div class="text-container">
            <span class="text">株式会社はっち</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          :title="t('代表責任者')"
        >
          <div class="text-container">
            <span class="text">八塚 健</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          :title="t('会社登記住所・営業所住所')"
        >
          <div class="text-container">
            <span class="text">〒542-0075</span>
            <span class="text">大阪府大阪市中央区難波千日前7-10 COCONAMBA4F</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          :title="t('電話番号')"
        >
          <div class="text-container">
            <span class="text">06-6643-9996</span>
            <!-- <span class="text" v-if="i18n_mode=='jp'">(※受付時間 : 平日10時-17時)</span> -->
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          :title="t('メールアドレス')"
        >
          <div class="text-container">
            <span class="text" v-if="i18n_mode=='jp'">
              takukh1231@gmail.com
            </span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          :title="t('価格')"
        >
          <div class="text-container">
            <span class="text">各商品毎に表示</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          :title="t('商品代金以外の必要料金')"
        >
          <div class="text-container left">
            <span class="text">
              当社の提供するサービスを利用するための機器に関する費用、インターネット接続料金、パケット通信料、消費税、代金支払いの振込手数料
            </span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          :title="t('引渡時期')"
        >
          <div class="text-container">
            <span class="text">申込受付時</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          :title="t('販売数量')"
        >
          <div class="text-container left">
            <span class="text">{{t('特に指定はございません。')}}</span>
            <span class="text">{{t('※商品によって数量制限設定あるものもございます。')}}</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          :title="t('お支払い方法')"
        >
          <div class="text-container left">
            <span class="text">
              {{t('クレジットカード・コンビニエンスストア・キャリア決済・メルペイとなります。')}}
            </span>
            <span class="text">
              {{t('※ご決済後のお客様都合によるキャンセルは承ることができません。予めご容赦ください。')}}
            </span>
            <span class="text">
              {{t('期限までにお支払いがない場合、自動的にキャンセルとなります。')}}
            </span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          :title="t('返品特約と期限')"
        >
          <div class="text-container left">
            <span class="text">
              {{t('返品・返還不可')}}
            </span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          :title="t('許認可・資格')"
        >
          <div class="text-container">
            <span class="text">{{t('古物商営業許可')}}</span>
            <span class="text">{{t('62111R061042')}}</span>
            <span class="text">{{t('大阪府公安委員会')}}</span>
          </div>
        </ShadowBoxTitleDescription>
      </div>
    </div>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import ShadowBoxTitleDescription from '@/components/molecules/ShadowBoxTitleDescription.vue';
import Title from '@/components/molecules/Title.vue';
import t from '@/plugins/i18n';

export default {
  name: 'SpecificCommerce',
  mixins: [t],

  components: {
    BaseTemplate,
    ShadowBoxTitleDescription,
    Title,
  },

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
    }),
  },

  created() {
    this.$store.dispatch('user/setCurrentUser', { token: 'yugi' });
  },
};
</script>

<style lang="scss" scoped>
.specific-commerce{
  width: 100%;
  max-width: 1600px;
  min-height: 100%;
  padding: 30px 20px 0;
  margin: 0 auto;
  color: #4a3f3a;
  .specific-commerce-title{
    display: flex;
    .text{
      height: 35px;
      font-family: $notoSerif;
      font-size: 24px;
      font-weight: 700;
      // color: $white;
    }
  }
  .scroll-container{
    width: 100%;
    margin-top: 30px;
    padding-bottom: 360px;
    max-width: 1000px;
    margin-left: auto;
    margin-right: auto;
    .shadow-box-title-description{
      width: 100%;
      .text-container{
        display: flex;
        flex-direction: column;
        padding: 5px 5px 0 5px;
        .text{
          font-family: $notoSans;
          font-size: 13px;
          line-height: 1.5;
          letter-spacing: 0.03em;
          // color: $white;
          &.margin-top{
            margin-top: 10px;
          }
          &.one-line-space-top{
            margin-top: 1em;
          }
        }
      }
      & + .shadow-box-title-description{
        margin-top: 40px;
      }
    }
  }
}
table.code {
  width: 620px;
  th, td {
    font-size: 13px;
    // color: $white;
  }
  th {
    font-weight: normal;
    text-align: left;
    padding-right: 10px;
  }
  td {
    text-align: left;
    padding-left: 10px;
  }
}
@media screen and  (max-width: $tabletWidth) {
  table.code {
    width: 100%;
    th, td {
      display: block;
    }
    th {
      text-align: left;
      padding-right: 0;
      &:after {
        content: '';
      }
    }
    td {
      text-align: left;
      padding-left: 0;
      padding-bottom: 10px;
    }
  }
  .left {
    text-align: left!important;
  }
}
</style>
